import React from 'react';
import LinkIcon from '../../components/Icons/LinkIcon';

import {
  Menu,
  LogOutButton,
  LinkButton,
  MenuFooter,
  MenuLinks,
  LinkText,
  ChatHistoryContainer,
  ChatHistoryTitle,
  NewChatButton,
  NewChatText,
  ChatHistoryItem,
  ChatHistoryItemButton
} from './styles';

const ChatbotMenu = ({ handleLogout, conversations, currentConversation, startNewChat, fetchPreviousChat, isBotReplying }) => {
  const sortedConversations = conversations.sort((a, b) => Number(b.sessionId) - Number(a.sessionId));

  return (
    <Menu>
      <ChatHistoryContainer>
        <NewChatButton onClick={() => startNewChat()} disabled={!currentConversation || isBotReplying}>
          <NewChatText>
            New Chat
          </NewChatText>
          <LinkIcon />
        </NewChatButton>
        {sortedConversations.length > 0 ? (
          <ChatHistoryTitle>Previous Chat</ChatHistoryTitle>
        ) : null}
        {sortedConversations?.map(item => (
          <div key={item.conversationId} style={{ width: '100%' }}>
            <ChatHistoryItemButton
              selected={item.conversationId === currentConversation}
              onClick={() => fetchPreviousChat(item.conversationId, item.sessionId)}
            >
              <ChatHistoryItem>
                {item.title?.length > 24 ? `${item.title.slice(0, 24)}...` : item.title}
              </ChatHistoryItem>
            </ChatHistoryItemButton>
          </div>
        ))}
      </ChatHistoryContainer>
      <MenuFooter>
        <MenuLinks>
          <LinkButton 
            href="/"
            target="_blank" 
            rel="noopener noreferrer">
            <LinkText>Instructions</LinkText>
            <LinkIcon />
          </LinkButton>
        </MenuLinks>
        <LogOutButton onClick={() => handleLogout()}>Log Out</LogOutButton>
      </MenuFooter>
    </Menu>
  );
};

export default ChatbotMenu;